import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { useGame } from '@/app/providers/GameContextProvider';
import { useGlobalPopup } from '@/app/providers/GlobalPopupProvider';
import { useGameModeSettingsContext } from '@/app/providers/GameModeSettingsProvider';
import { FightModeSettings, CoopModeSettings, CustomModeSettings } from '@/lib/types/common/GameModeAdvancedSettings';
import ToggleFFXIV from '@/app/components/ToggleFFXIV';

const NumberOfTeamsSelector: React.FC = () => {
    const { t } = useTranslation();
    const { room, gameState } = useGame();
    const { showPopup } = useGlobalPopup();
    const { settings, updateSettings, isGameMaster } = useGameModeSettingsContext();


    if (!room || !gameState) return null;

    const value = (settings as FightModeSettings | CoopModeSettings | CustomModeSettings).numberOfTeams ?? 2;
    const isFightMode = gameState.isEffectivelyFight;
    const minTeams = isFightMode ? 2 : 1;

    const handleNumberOfTeamsChange = (newTeams: number) => {
        if (isGameMaster) {
            updateSettings({ numberOfTeams: newTeams } as Partial<FightModeSettings>);
        } else {
            showPopup({
                type: 'error',
                message: t('lobby.onlyGameMasterCan'),
            });
        }
    };

    return (
        <div className="flex gap-7 items-center">
            <div className="text-[#EEE1C5] text-shadow-border shadow-black text-lg">
                {t('game.config.advancedSettings.numberOfTeams')}
            </div>
            <div className="flex gap-7">
                {Array.from({ length: 4 - minTeams + 1 }, (_, i) => i + minTeams).map((num) => (
                    <ToggleFFXIV
                        key={num}
                        value={value === num}
                        onChange={() => handleNumberOfTeamsChange(num)}
                        shape='circle'
                        text={num.toString()}
                    />
                ))}
            </div>
        </div>
    );
};

export default NumberOfTeamsSelector;
